import React from "react";

import { Route, Routes } from "react-router-dom";

import NotificationCardLayout from "@app/booking/layouts/NotificationLayout";

import CancelEvent from "./CancelEvent";
import EventDetails from "./EventDetails";
import EventError from "./notifications/EventError";
import InvalidEvent from "./notifications/InvalidEvent";
import PastEvent from "./notifications/PastEvent";

const EventDetailsRoutes = () => {
  return (
    <NotificationCardLayout>
      <Routes>
        <Route path=":eventId">
          <Route index element={<EventDetails />} />
          <Route path="cancel" element={<CancelEvent />} />
          <Route path="ended" element={<PastEvent />} />
        </Route>
        <Route path="404" element={<InvalidEvent />} />
        <Route path="500" element={<EventError />} />
      </Routes>
    </NotificationCardLayout>
  );
};

export default EventDetailsRoutes;
